import axios from 'axios';

export default axios.create({
    baseURL: 'https://api.yelp.com/v3/businesses',
    headers: {
        Authorization: 'Bearer xoEFTXRs1yqrKHDZuIXobA8p8mnl_Q0Nwwp3zkAIDAzGr7zHiDKqs7kVkb-0NECAxXX15cVDqYRPDuuTK0UWDO-PjVYoEGXd1V5O04DcroN0EPPZL3NWJuAURlViZHYx',
        'Access-Control-Allow-Origin': "*"
    }
});
